import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsSubwayFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_subway_filled"}/>
}
